// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__GyWms","productName":"Table_productName__26cCa"};